import { GlobalFormSetting } from '@/pages/components/GlobalFormSettings';
import React from 'react';

interface ISettingsContentProps {
  onSave: () => void;
  isMobile?: boolean;
}
/**
 * Settings content component for the trade area overlay
 * Contains the main settings interface
 */
const SettingsContent: React.FC<ISettingsContentProps> = ({ onSave, isMobile }) => {
  return (
    <div className="settings-content">
      <GlobalFormSetting isMobile={isMobile} onSave={onSave} />
    </div>
  );
};

export default SettingsContent;
